import { computed, Ref, ref } from 'vue'
import { enableLog, submitSurvey } from '@/utils/tools'
import { showFailToast } from 'vant'
import { nodeList } from '@/utils/answer'
import { Code, ErrorCode } from '@/types'
import { t } from '@/lang'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/stores/main'
import { useCache } from './useCache'
import { useCode } from './useCode'
function getErrorMsg(code: ErrorCode, num = 0) {
  switch (code) {
    case ErrorCode.Max:
      return t().A4(num)
    case ErrorCode.Min:
      return t().A3(num)
    case ErrorCode.MinText:
      return t().A6(num)
    case ErrorCode.Necessary:
      return t().A2()
  }
}

export function useAction(questions: Ref<any[]>, conf_id: Ref<string>) {
  const router = useRouter()
  const questionRef = ref<any>()
  const route = useRoute()
  const questionLen = computed(() => questions.value.length)
  const { currentIndex, surveyId, nodes, history, clear } = useCache(conf_id)
  /**  需要缓存的数据 end */
  const { showList } = useStore()
  const isPreview = computed(() => {
    return route.name === 'Preview'
  })

  const setCurrentIndex = (index: number) => {
    if (index > questionLen.value - 1) {
      submit()
      return
    }
    const question = questions.value[index]
    const qid = question.question_id
    if (qid && history.hideListHas(qid)) {
      setCurrentIndex(index + 1)
      return
    }
    currentIndex.value = index
    if (qid) {
      if (showList.value.includes(qid) && !history.showListHas(qid)) {
        setCurrentIndex(index + 1)
        return
      }
      currentIndex.value = index
    } else {
      setCurrentIndex(index + 1)
    }
  }

  const { handleCode } = useCode()

  const submit = async () => {
    const answerList = nodeList.getAnswerList(nodes.map((i) => questions.value[i].question_id))
    answerList.forEach((item) => {
      const { position } = item
      item.position = position.filter((i: any) => Boolean(i))
      item.answer = item.answer ?? ''
    })
    if (isPreview.value) {
      clear()
      return router.replace({
        name: 'End',
        query: {
          amount: 1 * 1000,
        },
      })
    }
    if (!surveyId.value) return
    if (enableLog()) {
      console.log('answerList', answerList)
    }
    const response = await submitSurvey(surveyId.value, answerList)
    clear()
    if (response.header?.code === Code.NORMAL) {
      return router.replace({
        name: 'End',
        query: {
          amount: response.data?.bonus_data?.prop_val || 0,
        },
      })
    }
    handleCode(response.header?.code as Code, response.header?.msg as string)
    // if (hit === false) {
    //   router.replace({
    //     name: 'error',
    //     query: {
    //       msg: encodeURIComponent(response.header?.msg || 'error'),
    //     },
    //   } as any)
    //   // showFailToast({
    //   //   message: response.header?.msg,
    //   //   duration: 3000,
    //   // })
    // }
  }

  const next = async (id: string) => {
    surveyId.value = id
    const { status, data, code, jump, hide, show, num } = await questionRef.value.validate()
    if (enableLog()) {
      console.log('next', { status, data, code, jump, hide, show, num })
    }
    if (!status) {
      const msg = getErrorMsg(code, num)
      return showFailToast(msg)
    }
    nodes.push(currentIndex.value)
    // 是否需要跳转
    if (jump) {
      // -1为结束页
      if (jump === -1) {
        nodeList.append({
          ...data,
        })
        await submit()
        return
      }

      const index = questions.value.findIndex((item: any) => item.question_id === jump)
      // 如果不存在该问题就自动跳到下一题
      if (index > -1) {
        nodeList.append({
          ...data,
          _index: currentIndex.value,
        })
        setCurrentIndex(index)
        return
      }
    }
    history.record(hide || [hide], show || [show])
    // 是否是最后一题
    if (currentIndex.value !== questionLen.value - 1) {
      const cur = currentIndex.value
      nodeList.append({
        ...data,
      })
      setCurrentIndex(cur + 1)
      return
    } else {
      nodeList.append({
        ...data,
      })
    }
    await submit()
  }

  const prev = () => {
    currentIndex.value = nodes.pop() ?? 0
    history.undo()
  }

  return {
    questionRef,
    currentIndex,
    next,
    prev,
  }
}
